@if (params.isEditing()) {
  @let planData = params.editData();

  <ng-select
    appendTo="body"
    placeholder="Select plan..."
    class="min-w-40"
    [bindValue]="'id'"
    [virtualScroll]="true"
    [(ngModel)]="planData[params.data.id].current.price_id"
    (change)="updateCurrentPlanData(params.data, $event)"
    [items]="params.selfServePrices()"
    [clearable]="true"
  >
    <ng-template ng-option-tmp let-item="item">
      {{ params.allPlanNamesByPriceId()[item.id] }}
    </ng-template>

    <ng-template ng-label-tmp let-item="item">
      {{ params.allPlanNamesByPriceId()[item.id] }}
    </ng-template>
  </ng-select>
} @else {
  <app-pan-plan-name [planName]="params.data._planName"></app-pan-plan-name>
}
